import React from 'react';
import { FormControl } from '@mui/material';

import { StyledTextField } from 'components/Input/styles';

import { ProtectorTypeNumberProps } from '../types';

import { ErrorMessage } from './styles';

export const CustomNumberInputField = ({
  value,
  description,
  onChange,
  maximum,
  minimum,
  requiredNotFilled,
  errorMessage,
}: Omit<ProtectorTypeNumberProps, 'items'>): React.ReactElement => {
  const [input, setInput] = React.useState(value);
  const [error, setError] = React.useState(false);

  // Sync local state with prop changes (e.g., when draft data is loaded)
  React.useEffect(() => {
    setInput(value);
  }, [value]);

  return (
    <FormControl fullWidth>
      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
      {error && (
        <ErrorMessage>{`Invalid number. Please enter a number between ${minimum} and ${maximum}`}</ErrorMessage>
      )}
      <StyledTextField
        error={requiredNotFilled}
        placeholder={description}
        value={input}
        onChange={(event) => {
          const val = event.target.value ? Number(event.target.value) : null;

          setInput(val);
          onChange(val);

          if ((maximum && val !== null && val > maximum) || (minimum && val !== null && val < minimum)) {
            setError(true);
            onChange('Invalid value');
          } else {
            setError(false);
          }
        }}
        onKeyDown={(event) => {
          // allow for decimal and positive sign
          if (event.key === 'e' || event.key === '+' || (!event.key.match(/^[0-9.]+$/) && event.key !== 'Backspace')) {
            event.preventDefault();
          }
          event.stopPropagation();
        }}
        variant="outlined"
        type="number"
        InputProps={{ inputProps: { min: minimum || undefined, max: maximum || undefined } }}
      />
    </FormControl>
  );
};

export default CustomNumberInputField;
